import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OnboardingCnStore {}

export enum OnboardingCnStoreKeys {}
